<template>
  <mu-card class="aio-input" id="blood-pressure-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="10px" viewBox="20 195 16 10" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32.000831,196.05636 C32.0007895,196.056319 32.0007064,196.056319 32.0006648,196.056278 C29.5330536,194.647969 26.4672788,194.647887 23.999626,196.056155 C23.9995014,196.056237 23.9993352,196.056278 23.9992105,196.05636 C21.6008227,197.424633 20,199.980785 20,202.890183 C20,203.059962 20.1395272,203.197531 20.31163,203.197531 L26.1818257,203.197531 C26.3304109,204.054991 27.0889184,204.709847 28,204.709847 C28.9149458,204.709847 29.6534259,204.084537 29.8156812,203.197531 L35.68837,203.197531 C35.8604728,203.197531 36,203.059962 36,202.890183 C36.0000416,199.979638 34.3982216,197.424059 32.000831,196.05636 L32.000831,196.05636 Z M28.0000416,204.095151 C27.326339,204.095151 26.7782441,203.554628 26.7782441,202.890183 C26.7782441,202.22668 27.3266298,201.685091 28.0001247,201.685091 C28.6587859,201.685091 29.2129056,202.206559 29.2215482,202.874118 C29.2187643,203.485085 28.7620809,204.095151 28.0000416,204.095151 L28.0000416,204.095151 Z M29.710558,202.195043 C29.655171,202.06272 29.583413,201.936707 29.4958242,201.819587 L30.3388873,201.602599 L29.710558,202.195043 L29.710558,202.195043 Z M30.2012715,202.582794 L31.6378444,201.228167 C31.8691985,201.00995 31.6538829,200.628962 31.3437903,200.708626 L29.334192,201.225872 L31.9554577,196.748098 C33.9382142,197.992776 35.2657581,200.135606 35.370258,202.582794 L30.2012715,202.582794 L30.2012715,202.582794 Z"
            id="Shape" stroke="none" fill="#FA6956" fill-rule="evenodd"></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="title"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon blueIcon"
            :icon="'add_circle'"
          ></mu-icon-button>
          <mu-icon-button
            v-if="isOpenInput"
            class="card-bar-icon blueIcon"
            :icon="'remove_circle_outline'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form @submit.prevent="saveReading" v-if="isOpenInput" style="overflow: hidden;">
      <mu-card-text>
        <mu-row>
          <mu-col width="100" tablet="50" desktop="50">
            <mu-text-field
              type="number"
              v-validate
              min="30"
              max="300"
              data-vv-rules="required|min_value:30|max_value:300"
              data-vv-name="systolic"
              data-vv-value-path="inputValue"
              :errorText="errors.first('systolic')"
              :label="$t('message.labelSystolic')"
              v-model.number="model.systolic"
              :hintText="$t('message.cardBloodPressuremmHGPlaceholder')"
              :fullWidth="true"
              :helpText="'mmHG'"
            />
          </mu-col>
          <mu-col width="100" tablet="50" desktop="50">
            <mu-text-field
              type="number"
              v-validate
              min="30"
              max="300"
              data-vv-rules="required|min_value:30|max_value:300"
              data-vv-name="diastolic"
              data-vv-value-path="inputValue"
              :errorText="errors.first('diastolic')"
              :label="$t('message.labelDiastolic')"
              v-model.number="model.diastolic"
              :hintText="$t('message.cardBloodPressuremmHGPlaceholder')"

              :helpText="'mmHG'"
            />
          </mu-col>
        </mu-row>
        <!--<mu-row class="bottom">
          <mu-col width="100" tablet="50" desktop="50">
            <mu-text-field
              type="number"
              v-validate
              min="0"
              max="220"
              :data-vv-rules="'min_value:0|max_value:220'"
              data-vv-name="pulse"
              data-vv-value-path="inputValue"
              :errorText="errors.first('pulse')"
              label="PULSE"
              v-model.number="model.pulse"
              hintText="Enter pulse"
              :fullWidth="true"
              :helpText="'BPM'"
            />
          </mu-col>
        </mu-row>-->
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>


  export default {
    name: 'aio-bloodPressure',
    data() {
      return {
        title: this.$t('message.cardBloodPressure'),
        isOpenInput: false,
        model: {
          systolic: null,
          diastolic: null,
          pulse: null
        }
      }
    },
    watch: {
      'model.systolic': function () {
        this.trySubmitAndEmitValue();
      },
      'model.diastolic': function () {
        this.trySubmitAndEmitValue();
      },
      'model.pulse': function () {
        this.trySubmitAndEmitValue();
      }
    },
    methods: {
      trySubmitAndEmitValue() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              let model = {};
              model.systolic = self.model.systolic;
              model.diastolic = self.model.diastolic;
              if (self.model.pulse !== null) {
                model.pulse = self.model.pulse;
              }
              self.$emit('onValid', model);
            }
            else {
              self.$emit('onValid', null);
            }
          })
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;

      },
    }
  }
</script>



// WEBPACK FOOTER //
// BloodPressure.vue?5e9f2b9a